var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOnebed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C21.6569 5 23 6.34315 23 8V20C23 21.6569 21.6569 23 20 23H8C6.34315 23 5 21.6569 5 20V8C5 6.34315 6.34315 5 8 5H20ZM8.79297 17.7422L7 15.9492V20.9492H12L10.207 19.1572L12.9502 16.4141L11.5352 15L8.79297 17.7422ZM15.0498 16.4141L17.793 19.1572L16 20.9492H21V15.9492L19.207 17.7422L16.4648 15L15.0498 16.4141ZM7 7V12L8.79297 10.207L11.5352 12.9492L12.9502 11.5352L10.207 8.79199L12 7H7ZM16 7L17.793 8.79199L15.0498 11.5352L16.4648 12.9492L19.207 10.207L21 12V7H16Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C21.6569 5 23 6.34315 23 8V20C23 21.6569 21.6569 23 20 23H8C6.34315 23 5 21.6569 5 20V8C5 6.34315 6.34315 5 8 5H20ZM8.79297 17.7422L7 15.9492V20.9492H12L10.207 19.1572L12.9502 16.4141L11.5352 15L8.79297 17.7422ZM15.0498 16.4141L17.793 19.1572L16 20.9492H21V15.9492L19.207 17.7422L16.4648 15L15.0498 16.4141ZM7 7V12L8.79297 10.207L11.5352 12.9492L12.9502 11.5352L10.207 8.79199L12 7H7ZM16 7L17.793 8.79199L15.0498 11.5352L16.4648 12.9492L19.207 10.207L21 12V7H16Z",
    fill: "url(#paint0_linear_10289_502905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10289_502905",
    x1: 14,
    y1: 5.77143,
    x2: 14,
    y2: 22.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnebed);
export default __webpack_public_path__ + "static/media/ic-onebed.5fbfdbae00a06996d162d4e483916478.svg";
export { ForwardRef as ReactComponent };